import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-05/lesson-18/task-03";

const task: Slide = {
  titleHtml:
    "If a room next to your apartment is an engine room with a lot of low-frequency noise,<br>choose the wall construction that will provide the best protection from that type of noise.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
